const STORAGE_KEY = 'clinio.journalLinkDeclined';

function readIds(): string[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

/** Nej on this note. A later open of the same note does not ask again. */
export function journalLinkDeclined(entryId: string | null | undefined): boolean {
  if (!entryId) return false;
  return readIds().includes(entryId);
}

export function rememberJournalLinkDeclined(entryId: string): void {
  if (typeof localStorage === 'undefined') return;
  const ids = readIds();
  if (ids.includes(entryId)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, entryId]));
}
